import HeaderBar from "../HeaderBar";
import Questions from "./Questions";

const FAQ = () => {
  return (
    <>
      <HeaderBar />
      <Questions />
    </>
  );
};

export default FAQ;
